<template>
    <PracticeTest/>
</template>
<script>
import PracticeTest from 'place/answer/practiceTest.vue'
export default {
    components:{
        PracticeTest
    }
}
</script>